<template>
    <v-row no-gutters class="grey lighten-1">
        <v-col cols="12" class="pa-4 d-flex justify-center align-center">
            <app-text v-if="$vuetify.breakpoint.mdAndUp" category="content-title">
                <div class="d-flex align-center">
                    <span class="pl-2">{{ photoViewer.title.slice(0, 40).concat('...') }}</span>
                </div>
            </app-text>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
            <!-- <appbutton :label="$t('buttons.delete')" icon="icons8-download" type="secondary"  class="mr-1" @click.native="MIX_deleteFile(photoViewer.photos[photoViewer.index].fileURL, photoViewer.photos[photoViewer.index].fileName)" /> -->
            <appbutton :label="$t('buttons.download')" icon="icons8-download" type="secondary"  class="mr-1" @click.native="MIX_downloadFile(photoViewer.photos[photoViewer.index].fileURL, photoViewer.photos[photoViewer.index].fileName)" />
        </v-col>
        <v-col cols="12" class="">
            <v-carousel hide-delimiters v-model="photoViewer.index" :width="photoViewer.width" :height="photoViewer.height" >
                <v-carousel-item
                    v-for="(item,i) in photoViewer.photos"
                    :key="i"
                    :src="item.fileURL">
                </v-carousel-item>
            </v-carousel>
        </v-col>
    </v-row>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        // * DATA
        data: () => ({
            photoViewer: {
                title: '',
                index: 0,
                photos: [],
                width: '',
                height: '',
            },
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_photoViewer: 'photoViewer_store/GET_photoViewer'
            })
        },
        // * METHOD
        methods: {
    
        },
        // * WATCH
        watch: {
            GET_photoViewer: {
                handler() {
                    this.photoViewer = this.GET_photoViewer;
               }, deep: true
            }
        },
        // * MOUNTED
        mounted() {
            this.photoViewer = this.GET_photoViewer;
        }

    }
</script>